var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"white"}},[_c('v-container',{staticClass:"app-bar-centered"},[_c('v-toolbar-title',{staticClass:"logo"},[_c('img',{attrs:{"src":require('../../assets/logo.svg'),"alt":"logo"}}),_c('span',{staticClass:"text"},[_vm._v("COPA")])]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{ name: 'home.index' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('v-btn',{class:isExactActive ? 'is-active' : '',attrs:{"text":"","small":"","href":href},on:{"click":navigate}},[_vm._v(" "+_vm._s(_vm.$t('home.link'))+" ")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'about' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('v-btn',{class:isActive ? 'is-active' : '',attrs:{"text":"","small":"","href":href},on:{"click":navigate}},[_vm._v(" "+_vm._s(_vm.$t('about.link'))+" ")])]}}])}),_c('router-link',{attrs:{"to":{ name: 'privacy' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('v-btn',{class:isActive ? 'is-active' : '',attrs:{"text":"","small":"","href":href},on:{"click":navigate}},[_vm._v(" "+_vm._s(_vm.$t('privacy.link'))+" ")])]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }